// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3N2rm","footer":"Form_footer__194WW"};